<app-page>
    <br>
    <h1 align="center">{{ 'page_not_found' | translate }}</h1>
    <div align="center">
        <app-action [text]="'return_home' | translate" (onExecute)="goToHomePage()">
        </app-action>
    </div>
</app-page>
